import React from 'react';
import TrainingPage from '../components/training/TrainingPage';
import trainingContent from '../config/trainingContent';

export default function GeminiEnterpriseTraining() {
  return (
    <TrainingPage
      seo={{
        title: "Google Gemini Training for Enterprise Teams | Eagentix",
        description: "1-day onsite Google Gemini training delivered inside your own Workspace. Hands-on with your Docs, Sheets, Slides, Gmail and Drive — with a shared standard your team keeps."
      }}
      content={trainingContent.gemini}
    />
  );
}
